"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("../../../helpers");
var IcAndroid_1 = __importDefault(require("../assets/IcAndroid"));
var IcBlog_1 = __importDefault(require("../assets/IcBlog"));
var IcFacebook_1 = __importDefault(require("../assets/IcFacebook"));
var IcInstagram_1 = __importDefault(require("../assets/IcInstagram"));
var IcIos_1 = __importDefault(require("../assets/IcIos"));
var IcLinkedin_1 = __importDefault(require("../assets/IcLinkedin"));
var IcTwitter_1 = __importDefault(require("../assets/IcTwitter"));
var IcYoutube_1 = __importDefault(require("../assets/IcYoutube"));
var LogoHorizontalIt_1 = __importDefault(require("../assets/LogoHorizontalIt"));
var configuration = {
    copyright: {
        link: {
            props: {
                href: '//it.privalia.com/microsites/index',
                title: 'Privalia'
            }
        },
        logo: LogoHorizontalIt_1.default,
        sentence: "Copyright \u00A9 Privalia Vendita Diretta SRL 2007-" + helpers_1.getCurrentYear()
    },
    main: {
        about: {
            links: [{
                    label: 'Chi siamo',
                    props: {
                        href: '//it.privalia.com/public/about',
                        title: 'Chi siamo'
                    }
                }, {
                    label: 'Leggi di più su Veepee',
                    props: {
                        href: '//www.veepee.it',
                        style: {
                            color: '#ec008c'
                        },
                        target: '_blank',
                        title: 'Leggi di più su Veepee'
                    }
                }, {
                    label: 'Politica sulla privacy',
                    props: {
                        onClick: function () {
                            window.open('https://it.privalia.com/front/get/doc/politica-sulla-privacy.pdf?v=201906191410', 'popup', 'width=600,height=600');
                        },
                        target: '_blank',
                        title: 'Politica sulla privacy'
                    }
                }, {
                    label: 'Politica sui cookies',
                    props: {
                        onClick: function () {
                            window.open('https://it.privalia.com/front/get/doc/politica-sui-cookies.pdf?v=201906191410', 'popup', 'width=600,height=600');
                        },
                        target: '_blank',
                        title: 'Politica sui cookies'
                    }
                }, {
                    label: 'Condizioni d\'uso e vendita',
                    props: {
                        onClick: function () {
                            window.open('https://it.privalia.com/front/get/doc/condizioni-generali-di-vendita-online.pdf?v=201906191410', 'popup', 'width=600,height=600');
                        },
                        target: '_blank',
                        title: 'Condizioni d\'uso e vendita'
                    }
                }],
            title: 'Su Privalia'
        },
        awards: {
            awards: ['Sito Web\ndell\'Anno 2015', 'Netcomm\nE-COMMERCE\nAward 2013'],
            title: 'Riconoscimenti'
        },
        contact: {
            links: [{
                    label: 'Aiuto',
                    props: {
                        href: '//it.privalia.com/help/indexpub',
                        title: 'Aiuto'
                    }
                }, {
                    label: 'Blog',
                    props: {
                        href: '//blog.it.privalia.com/',
                        target: '_blank',
                        title: 'Blog'
                    }
                }],
            title: 'Contattaci'
        },
        premium: {
            link: {
                label: 'Diventa Premium',
                props: {
                    href: '//it.privalia.com/public/premium/',
                    title: 'Diventa Premium'
                }
            },
            sentence: 'Approfitta di tutte le occasioni di Privalia',
            title: 'Premium'
        }
    },
    top: {
        left: {
            links: [{
                    icon: IcIos_1.default,
                    label: 'iOS',
                    props: {
                        href: '//it.privalia.com/public/mobile#slide2',
                        title: 'iOS'
                    }
                }, {
                    icon: IcAndroid_1.default,
                    label: 'Android',
                    props: {
                        href: '//it.privalia.com/public/mobile#slide1',
                        title: 'Android'
                    }
                }],
            title: 'Scarica la nostra app'
        },
        right: {
            links: [{
                    icon: IcFacebook_1.default,
                    props: {
                        href: '//www.facebook.com/privalia.it',
                        target: '_blank',
                        title: 'Privalia Facebook'
                    }
                }, {
                    icon: IcTwitter_1.default,
                    props: {
                        href: '//twitter.com/privalia_it',
                        target: '_blank',
                        title: 'Privalia Twitter'
                    }
                }, {
                    icon: IcInstagram_1.default,
                    props: {
                        href: '//instagram.com/privalia_it',
                        target: '_blank',
                        title: 'Privalia Instagram'
                    }
                }, {
                    icon: IcBlog_1.default,
                    props: {
                        href: '//blog.it.privalia.com/',
                        target: '_blank',
                        title: 'Privalia Blog'
                    }
                }, {
                    icon: IcYoutube_1.default,
                    props: {
                        href: '//www.youtube.com/user/PrivaliaIT',
                        target: '_blank',
                        title: 'Privalia YouTube'
                    }
                }, {
                    icon: IcLinkedin_1.default,
                    props: {
                        href: '//www.linkedin.com/company/privalia',
                        target: '_blank',
                        title: 'Privalia LinkedIn'
                    }
                }],
            title: 'Seguici su'
        }
    }
};
exports.default = configuration;
